/**
 * Tuning values for the dashboard Calendar widget (CU-868m4dmaq).
 * Every threshold the widget reads lives here so it can be tuned in one place.
 */

/** `widget_name` in the dashboard-wide Dashboard Widget Item Clicked and Control Clicked events (widgetAnalytics.js). */
export const CALENDAR_WIDGET_NAME = 'Calendar';

/** The calendar's own measured width (CSS px) at which the seven-column week layout appears. */
export const HORIZONTAL_LAYOUT_MIN_WIDTH = 1120;

/** Calendar width (CSS px) below which each day row puts its day header above the cards, so a card keeps the full width. */
export const MIN_CALENDAR_WIDTH = 420;

/**
 * Calendar width (CSS px) below which the Day strip drops its side padding and uses 1 px gaps. With padding, seven
 * 44 px tiles need 356 px; without it they need 314 px.
 */
export const DAY_STRIP_COMPACT_WIDTH = 360;

/** The scroll area must show at least this many full entries before it scrolls. */
export const MIN_VISIBLE_ENTRIES = 3;

/** Pixels one click on a "More" pill scrolls. */
export const MORE_PILL_SCROLL_STEP = 120;

/** Scroll offset (px) under which an edge counts as reached. */
export const SCROLL_EDGE_TOLERANCE = 2;

/** Narrowest grid span (of 12 columns) the calendar can be resized to. */
export const CALENDAR_MIN_GRID_COLUMNS = 6;

/**
 * Shortest grid height (dashboard rows) for the calendar. 10 rows is about 520 px, which leaves room for the
 * header, week bar, footer and a body that holds MIN_VISIBLE_ENTRIES cards.
 */
export const CALENDAR_MIN_GRID_ROWS = 10;

/** Grid rows the calendar takes on a phone: header, week bar, day strip, the 24rem agenda and the footer (about 790 px). */
export const CALENDAR_MOBILE_GRID_ROWS = 15;

/** Body heights used when the dashboard grid does not own the widget's height (phone and the add-widget preview). */
export const FIXED_BODY_HEIGHTS = {
    horizontal: '26rem',
    vertical: '36rem',
    day: '24rem',
};

export const CALENDAR_LAYOUTS = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    day: 'day',
};

export const CALENDAR_VIEWS = {
    week: 'week',
    day: 'day',
};
